import React from 'react';
import PropTypes from 'prop-types';
import PartnerLicensePackageUsageSummary from './PartnerLicensePackageUsageSummary';
import { PartnerLicensePackageUsageRateListService } from '../../services/CustomerSuccessKpiListService';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { get } from 'lodash';

class PartnerLicensePackageUsageSummaryContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    PartnerLicensePackageUsageRateListService.load();
  }

  render() {
    const data = toJS(PartnerLicensePackageUsageRateListService.getSummaryByType(this.props.type, this.props.typeId));
    return (
      <PartnerLicensePackageUsageSummary
        isLoading={
          PartnerLicensePackageUsageRateListService.fetchCurrent.fetching ||
          PartnerLicensePackageUsageRateListService.fetchPrevious.fetching
        }
        currentValue={get(data, 'current')}
        previousValue={get(data, 'previous')}
        standardDeviationValue={get(data, 'currentStandardDeviation')}
        formatter={PartnerLicensePackageUsageRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerLicensePackageUsageSummaryContainer);
